module.exports = __webpack_public_path__ + "static/media/img-customer.03e1a00e.jpg";